var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 80C160 82.3619 159.899 84.6981 159.697 87.0086C156.146 127.909 121.82 160 80 160C35.8171 160 0 124.183 0 80C0 37.0457 33.8543 2 76.3371 0.0828571C77.5523 0.027619 78.7733 0 80 0H138.831L127.763 15.82L108.857 42.8571H80C78.7619 42.8571 77.5409 42.9162 76.3371 43.0343C69.4811 43.7152 62.9496 46.2897 57.4729 50.4698C51.9961 54.6499 47.7899 60.271 45.3246 66.7045C42.8592 73.138 42.2319 80.1305 43.5127 86.9001C44.7935 93.6698 47.9319 99.9497 52.5772 105.038C57.2224 110.126 63.1913 113.822 69.8166 115.713C76.4419 117.603 83.4624 117.613 90.0933 115.743C96.7242 113.872 102.704 110.194 107.364 105.119C112.025 100.045 115.182 93.7744 116.483 87.0086H77.9514L95.0942 62.4971L102.334 52.1486L103.16 50.9686L108.857 42.8571H150.886C153.263 47.379 155.198 52.1201 156.663 57.0143C156.677 57.06 156.688 57.1057 156.703 57.1514C158.901 64.5682 160.011 72.2645 160 80Z",
    fill: "url(#paint0_linear_1_926)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_926",
    x1: 160,
    y1: -0.00000476837,
    x2: -0.0000143051,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE722A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D51757"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.677be668f542a8b64089b80ec1c10d54.svg";
export { ForwardRef as ReactComponent };